import { render, staticRenderFns } from "./my-taxes.vue?vue&type=template&id=5ee6b95b&scoped=true&"
import script from "./my-taxes.vue?vue&type=script&lang=js&"
export * from "./my-taxes.vue?vue&type=script&lang=js&"
import style0 from "./my-taxes.vue?vue&type=style&index=0&id=5ee6b95b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6b95b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VDataTable,VIcon})
